import {nonFeaturedGameMaps} from './FeaturedContentDataTypes'
import {SocketDataTypes} from './SocketDataTypes'
import {RoomSettingConstants, ModeSettingEnum} from '@colonist/game-base-types'

export class GameSorter {
    private readonly NO_TROLLS_GAME_STRENGTH = 90
    private readonly MODE_PRIORITY_STRENGTH = 30
    private readonly MAP_PRIORITY_STRENGTH = 20
    private readonly PLAYER_COUNT_PRIORITY_STRENGTH = 10
    private readonly PLAYER_COUNT_PRIORITY_PENALTY = -100

    sort(gameContainerList: SocketDataTypes.LobbyRowData[], userKarma?: number): SocketDataTypes.LobbyRowData[] {
        const gameContainerListClone = [...gameContainerList]
        if(userKarma == undefined) return this.sortGameList(gameContainerListClone)

        const eligibleGames = gameContainerListClone.filter((gameContainer: SocketDataTypes.LobbyRowData) => userKarma >= gameContainer.minimumKarma)
        const ineligibleGames = gameContainerListClone.filter((gameContainer: SocketDataTypes.LobbyRowData) => userKarma < gameContainer.minimumKarma)

        const sortedEligibleGames = this.sortGameList(eligibleGames)
        const sortedIneligibleGames = this.sortGameList(ineligibleGames)

        const allSortedGames = sortedEligibleGames.concat(sortedIneligibleGames)
        return allSortedGames
    }

    private sortGameList(gameContainerList: SocketDataTypes.LobbyRowData[]): SocketDataTypes.LobbyRowData[] {
        const gameContainerListClone = [...gameContainerList]
        const sortedList = gameContainerListClone.sort((previousContainer: SocketDataTypes.LobbyRowData, nextContainer: SocketDataTypes.LobbyRowData) => this.getScore(nextContainer) - this.getScore(previousContainer))
        return sortedList
    }

    private getScore(gameContainer: SocketDataTypes.LobbyRowData): number {
        let score = 0
        score += this.getNoTrollsScore(gameContainer)
        score += this.getModeScore(gameContainer)
        score += this.getMapScore(gameContainer)
        score += this.getPlayerCountScore(gameContainer)
        return score
    }

    private getNoTrollsScore(gameContainer: SocketDataTypes.LobbyRowData): number {
        const isNoTrollsGame = gameContainer.minimumKarma != RoomSettingConstants.DEFAULT_KARMA_THRESHOLD
        if(isNoTrollsGame) return this.NO_TROLLS_GAME_STRENGTH
        return 0
    }

    private getModeScore(gameContainer: SocketDataTypes.LobbyRowData): number {
        const modeSetting = gameContainer.gameModeSetting
        return GameSorter.getModePriority(modeSetting) * this.MODE_PRIORITY_STRENGTH
    }

    private getMapScore(gameContainer: SocketDataTypes.LobbyRowData): number {
        const isMapFeatured = !nonFeaturedGameMaps.has(gameContainer.gameMapSetting)
        if(isMapFeatured) return this.MAP_PRIORITY_STRENGTH
        return 0
    }

    private getPlayerCountScore(gameContainer: SocketDataTypes.LobbyRowData): number {
        const activePlayerCount = gameContainer.players.length
        const score = activePlayerCount / gameContainer.maxPlayers
        return score < 1 ? score * this.PLAYER_COUNT_PRIORITY_STRENGTH : this.PLAYER_COUNT_PRIORITY_PENALTY
    }

    private static getModePriority(modeSetting: ModeSettingEnum): number {
        switch(modeSetting) {
            case ModeSettingEnum.ColonistRush4P:
                return 5
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
                return 4
            case ModeSettingEnum.CitiesAndKnights4P:
            case ModeSettingEnum.CitiesAndKnights56P:
                return 3
            case ModeSettingEnum.Seafarers4P:
            case ModeSettingEnum.Seafarers56P:
                return 2
            case ModeSettingEnum.Classic56P:
            case ModeSettingEnum.Classic78P:
                return 1
            default:
                return 0
        }
    }
}
